import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaBlog = props => {
  if (props.id !== "_svgsocialmediablog") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#333"><path d="M120 15C62.562 15 16 61.562 16 119s46.562 104 104 104 104-46.562 104-104S177.438 15 120 15zm0 196c-50.729 0-92-41.271-92-92s41.271-92 92-92 92 41.271 92 92-41.271 92-92 92z" /><path d="M100.877 115.93a6 6 0 000 12c8.377 0 15.193 6.815 15.193 15.193s-6.816 15.193-15.193 15.193c-8.378 0-15.195-6.815-15.195-15.193V95.455a6 6 0 00-12 0v47.668c0 14.994 12.2 27.193 27.195 27.193 14.995 0 27.193-12.199 27.193-27.193s-12.198-27.193-27.193-27.193zM114.181 95.747a6 6 0 000 12c12.171 0 22.073 9.902 22.073 22.073a6 6 0 0012 0c0-18.788-15.285-34.073-34.073-34.073z" /><path d="M110.923 69.683a6 6 0 000 12c28.339 0 51.394 23.055 51.394 51.394a6 6 0 0012 0c-.001-34.955-28.439-63.394-63.394-63.394z" /></g></svg>;
};

SvgSocialmediaBlog.displayName = "_svgsocialmediablog";
SvgSocialmediaBlog.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaBlog.defaultProps = {
  id: ''
};
export default SvgSocialmediaBlog;